import React from "react"

import BlurWrapper from "@fuse/sharedComponents/blurWrapper"
import BlurComponentWrapper from "@fuse/sharedComponents/blurWrapper/BlurComponentWrapper"
import { blurKeys } from "@fuse/sharedComponents/blurWrapper/blurKeysList"
import { EButtonType } from "@letshang/constants"

export type TButtonVariant = keyof typeof EButtonType

const LoadingSpinner = () => {
  return (
    <svg
      className="animate-spin h-5 w-5"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  )
}

interface ButtonProps {
  size?: "sm" | "md" | "lg"
  variant?: TButtonVariant
  disabled?: boolean
  isLoading?: boolean
  icon?: string | React.ReactElement
  children: React.ReactNode | string
  onClick?: () => void
  className?: string
}

const Button: React.FC<ButtonProps> = ({
  size = "md",
  variant = EButtonType.solid,
  disabled = false,
  isLoading = false,
  icon,
  children,
  onClick,
  className = "",
}) => {
  // Base styles for the button
  const baseStyles = `flex items-center justify-center font-semibold rounded-full focus:outline-none transition duration-300 hover:cursor-pointer`

  // Size classes
  const sizeClasses = {
    sm: "text-sm px-3 py-1.5",
    md: "text-md px-4 py-2",
    lg: "text-md px-5 py-3",
  }

  // Variant classes
  const variantClasses = {
    [EButtonType.solid]:
      disabled || isLoading
        ? "border border-white/20 pointer-events-none text-gray-300"
        : "border border-white/20 text-white",
    [EButtonType.outline]:
      disabled || isLoading
        ? "bg-transparent border border-white/20 text-gray-300 pointer-events-none"
        : "bg-transparent border border-white/20 text-white",
  }

  return (
    <BlurComponentWrapper
      className={`${baseStyles} ${sizeClasses[size]} ${variantClasses[variant]} ${
        variant === "outline" ? "bg-transparent" : ""
      } ${className} gap-2 `}
      onClick={!disabled && !isLoading ? onClick : undefined}
      disabled={disabled}
    >
      <button
        // onClick={(e) => {
        //   e.stopPropagation()
        //   onClick()
        // }}
        disabled={disabled || isLoading}
        className="p-0 bg-transparent flex gap-2 items-center"
      >
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            {typeof icon === "string" ? (
              <span className="">{<img src={icon} />}</span>
            ) : (
              icon
            )}
            {children}
          </>
        )}
      </button>
    </BlurComponentWrapper>
  )
}

export default Button
